export const obfuscatePhone = (str: string) => {
  const init = str.slice(0, 3);

  return `${init} *****`;
};
